import * as preact from 'preact'

const { h, Component } = preact

const ESI_PREFIX = 'https://nrk.no'
const IS_CLIENT = typeof window !== 'undefined'

interface Props {
  path: string;
  get?: (string: string) => Promise<string>;
}

interface State {
  fetchedHtml: string | null;
}

export class EsiInclude extends Component<Props, State> {
  state = {
    fetchedHtml: null
  }

  shouldComponentUpdate(nextProps: Props, nextState: State) {
    return this.state.fetchedHtml !== nextState.fetchedHtml
  }

  componentDidMount(): void {
    const { get, path } = this.props
    if (get) {
      get(path)
        .then(fetchedHtml => this.setState({ fetchedHtml }))
        .catch(console.error)
    }
  }

  render() {
    const { path, get } = this.props
    const esiUrl = `${ESI_PREFIX}${path}`
    if (!get) {
      if (IS_CLIENT) {
        const html = document.querySelector(`[data-esi-url="${path}"]`)
        if (html) {
          return <div dangerouslySetInnerHTML={{ __html: html.innerHTML }} />
        }
        return null
      }
      return (
        <div
          data-esi-url={path}
          dangerouslySetInnerHTML={{ __html: `<esi:include src="${path}" />` }}
        />
      )
    } else {
      const { fetchedHtml } = this.state
      if (!fetchedHtml) {
        return <div />
      } else {
        return <div data-esi-url={esiUrl} dangerouslySetInnerHTML={{ __html: fetchedHtml }} />
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/lib/ESI.tsx